import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { getPreorders } from './../../../../store/reducers/orders';
import OrderRow from './order-row-preorder';
import Drawer from 'material-ui/Drawer';
import PaymentConditionsInfo from './../prepare-order/payment-conditions-info';

const Preorders = props => {
  const { elems, keys, rowsState, containerHeight, ...other } = props;
  const styles = Preorders.prepareStyles(containerHeight);
  const { preordersContainerStyle, preordersListStyle } = styles;

  return (
    <div className='preordersContainer' id='preordersContainer' style={preordersContainerStyle}>
      <div className='preordersList' style={preordersListStyle}>
        { keys.map(key => <OrderRow key={key} {...other} order={elems[key]} rowsState={rowsState} />) }
      </div>
    </div>
  );
}

Preorders.prepareStyles = containerHeight => (
  {
    preordersContainerStyle: {
      padding: '10px',
      height: `${containerHeight - 150}px`,
      // height: '70px',
      overflowY: 'scroll'
    },
    preordersListStyle: {
      display: 'flex',
      flexDirection: 'column'
    }
  }
)


Preorders.propTypes = {
  elems: PropTypes.arrayOf(PropTypes.shape({
    comment: PropTypes.string,
    date: PropTypes.string.isRequired,
    id: PropTypes.string.isRequired,
    requestedDelivDate: PropTypes.string.isRequired,
    requested: PropTypes.object.isRequired,
    status: PropTypes.number.isRequired,
    type: PropTypes.oneOf(['m', 'a'])
  })),
  keys: PropTypes.array.isRequired,
  accessories: PropTypes.object.isRequired,
  sets: PropTypes.object.isRequired,
  toggleRowState: PropTypes.func.isRequired //from container
}

class PreordersContainer extends Component {
  constructor() {
    super();
    this.state = { rowsState: {}, containerHeight: 500, paymentConditionsOpen: false, orderId: '' };
  }
  componentDidMount() {
    const containerHeight = document.body.offsetHeight - document.getElementById('headerContainer').offsetHeight - document.getElementById('footerContainer').offsetHeight;
    this.setState({ containerHeight });
  }
  toggleRowState = key => {
    const curState = this.state.rowsState;
    this.setState({ rowsState: { ...curState, [key]: !curState[key] }})
  }
  togglePaymentConditions = orderId => {
    this.setState({ paymentConditionsOpen: !this.state.paymentConditionsOpen, orderId })
  }
  render () {
    return (
      <div>
        <Drawer
          docked={false}
          width={560}
          open={this.state.paymentConditionsOpen}
          onRequestChange={
            () => {
              this.togglePaymentConditions('')
            }
          }
        >
          {this.state.paymentConditionsOpen &&
            <div style={{padding: '12px'}}>
              <PaymentConditionsInfo togglePaymentConditions={this.togglePaymentConditions} orderId={this.state.orderId} />
            </div>
          }
        </Drawer>
        <Preorders
          {...this.props}
          rowsState={this.state.rowsState}
          toggleRowState={this.toggleRowState}
          containerHeight={this.state.containerHeight}
          paymentConditionsOpen={this.state.paymentConditionsOpen}
          togglePaymentConditions={this.togglePaymentConditions}
        />
      </div>
    );
  }
}

export default connect(
  state => {
    const elems = getPreorders(state.orders);
    const { accessories, sets } = state;
    return ({ elems, keys: Object.keys(elems), accessories, sets })
  }
)(PreordersContainer);



// WEBPACK FOOTER //
// ./src/components/layout/content/orders/preorders.js